export const environment = {
  production: false,
    baseUrl: "https://x48iq1czp0.execute-api.ap-south-1.amazonaws.com/test/",
  cloudFrontUrl: "https://d6b26pnpznhjw.cloudfront.net/",
  s3AccessKeyId: "AKIA2SM7JXMSKUXQWFBM",
  s3SecretAccessKey: "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",
  awsRegion: "ap-south-1",
  UserPoolId: "ap-south-1_s8NIFVQLZ",
  ClientId: "4d3l0nbtntqp68e34gh8lguupl",
  bucketName: "prod.lms.assets",
  examBaseUrl: "https://pjy2xedxid.execute-api.ap-south-1.amazonaws.com/dev/",
  encryptionKey : "vOVH6sdmpNWjRRIqCc7rdxs01lwHzfr7",
  drmConfiguration: {
    server: {
      "com.widevine.alpha":
        "https://lic.drmtoday.com/license-proxy-widevine/cenc/?specConform=true",
      "com.microsoft.playready":
        "https://lic.drmtoday.com/license-proxy-headerauth/drmtoday/RightsManager.asmx",
    },
  },
  clinicalLearning:"5fb667b7cc305300084bbda0",
  aesEncryptionKey:"vOVH6sdmpNWjRRIqCc7rdxs01lwHzfr3",
};
